import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { usePmsApprovalStatus, PmsApprovalStatus } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => (
  <GenericFormPage<PmsApprovalStatus>
    useData={usePmsApprovalStatus}
    config={{
      ...moduleConfig,
      getInitialFormData,
      mapItemToFormData,
    }}
  />
);

export default Form;
